<mat-form-field class="full-width form-field">
  <mat-label>{{label}}</mat-label>
  <input id="ip{{label | stripSpaces}}" matInput step="any" [(ngModel)]="value" (change)="valueChanged(value)" (input)="input(value)" type="number" 
  [required]="required" [min]="min" [customMin]="min" [max]="max" [customMax]="max" [disabled]="readonly" #ip="ngModel" attr.aria-label="{{label}}">
</mat-form-field>
<validation-errors [control]="ip" [min]="min" [max]="max"></validation-errors>
